export default __webpack_public_path__ + "static/media/36I-114281_-20892_0.cdb19667.jpg";